<div class="content py-0">
    <div class="footer-background p-5 body-content-gray">
        <div
            class="row col-lg-4 offset-lg-4 col-md-8 offset-md-2 col-12 text-white d-flex justify-content-center pr-0 py-4">
            <div class="row">
                <div class="col-4">
                    <img src="assets/images/logo.png" alt="logo">
                </div>
                <div class="col-8">
                    <div class="row">
                        <span class="text-size-14 font-weight-light">Sporty's</span>
                    </div>
                    <div class="row">
                        <span class="text-size-26 font-weight-light">Pilot Training +</span>
                    </div>
                </div>
            </div>
            <div class="row pt-2 px-3">
                <span class="text-size-32 mt-1 d-flex text-center">GET ACCESS TO SPORTY'S COMPLETE
                    COURSE LIBRARY</span>
            </div>
            <div class="row px-3 mt-2">
                <span class="text-size-16 font-weight-light text-center mt-1 mt-md-4">For one annual
                    fee, you get access to over $1,500 in courses—a smart investment in your flying career.</span>
            </div>
            <div class="row pb-5 mt-3 mt-md-4 d-flex justify-content-md-start justify-content-center">
                <a href="https://www.sportys.com/sportys-pilot-training-plus.html#reviews" target="_blank"
                    class="btn border-white btn-round cursor-pointer py-2 text-white">
                    Reviews
                </a>
                <a href="https://www.sportys.com/sportys-pilot-training-plus.html?utm_source=onlinecoursedemo&utm_medium=referral&utm_content=PTPportalbutton" target="_blank"
                    class="btn btn-primary btn-round ml-3 px-5">Gain Access Now</a>
            </div>
        </div>
        <hr class="w-100 my-2 d-md-block d-none color-white">
        <div class="d-md-flex d-none row text-white">
            <div class="col-2">
                <div class="row d-flex justify-content-center">
                    <span class="text-size-26">30+</span>
                </div>
                <div class="row w-100 mx-0">
                    <span class="text-size-14 px-2 text-center w-100"> Aviation Training Courses</span>
                </div>
            </div>
            <div class="col-2">
                <div class="row d-flex justify-content-center">
                    <span class="text-size-26">70+</span>
                </div>
                <div class="row w-100 mx-0">
                    <span class="text-size-14 px-2 text-center w-100">Hours of Training Videos</span>
                </div>
            </div>
            <div class="col-2">
                <div class="row d-flex justify-content-center">
                    <span class="text-size-26">30+</span>
                </div>
                <div class="row w-100 mx-0">
                    <span class="text-size-14 px-2 text-center w-100">Classic Air Facts Videos with Richard
                        Collins</span>
                </div>
            </div>
            <div class="col-2">
                <div class="row d-flex justify-content-center">
                    <span class="text-size-26">$399</span>
                </div>
                <div class="row w-100 mx-0">
                    <span class="text-size-14 px-2 text-center w-100">Yearly Subscription Worth $1,500 Value</span>
                </div>
            </div>
            <div class="col-2">
                <div class="row d-flex justify-content-center">
                    <span class="text-size-26">Lifetime</span>
                </div>
                <div class="row w-100 mx-0">
                    <span class="text-size-14 px-2 text-center w-100">Lifetime Access to Learn to Fly Course</span>
                </div>
            </div>
            <div class="col-2">
                <div class="row d-flex justify-content-center">
                    <span class="text-size-26">New</span>
                </div>
                <div class="row w-100 mx-0">
                    <span class="text-size-14 px-2 text-center w-100">Automatic Access to New Courses</span>
                </div>
            </div>
        </div>
    </div>
</div>